import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActionConfirmationDialogComponent } from '../action-confirmation-dialog/action-confirmation-dialog.component';
import { MessageDialogBoxDataFormGroup } from './message-dialog-box-data-form-group';
import { MessageDialogBoxDataModel } from './message-dialog-box-data.model';
import { AbstractActionConfirmationDialogComponent } from '../abstract-action-confirmation-dialog/abstract-action-confirmation-dialog.component';
import { MatFormField } from '@angular/material/form-field';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatInput } from '@angular/material/input';
import { FirstLetterUpperCaseDirective } from '../../../../shared/directives/first-letter-upper-case.directive';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-action-confirmation-message-dialog',
  styleUrls: ['./action-confirmation-message-dialog.component.scss'],
  templateUrl: './action-confirmation-message-dialog.component.html',
  imports: [
    AbstractActionConfirmationDialogComponent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    CdkTextareaAutosize,
    MatInput,
    FirstLetterUpperCaseDirective,
  ],
})
export class ActionConfirmationMessageDialogComponent {
  public data: MessageDialogBoxDataModel;
  public dialogRef = inject<MatDialogRef<ActionConfirmationDialogComponent>>(MatDialogRef);
  public formGroup: FormGroup<MessageDialogBoxDataFormGroup>;

  private _data = inject<MessageDialogBoxDataModel>(MAT_DIALOG_DATA);

  public constructor() {
    const _data = this._data;

    this.data = _data;
    if (!this._data.acceptLabel) {
      this.data.acceptLabel = 'Oui';
    }
    if (!this._data.declineLabel) {
      this.data.declineLabel = 'Non';
    }
    this._createForm(_data);
  }

  public onAcceptClickedHandler(): void {
    if (this._data.onAccept) {
      this._data.onAccept(this.formGroup.controls?.message?.value);
    }
    this.dialogRef.close(true);
  }

  public onDeclineClickedHandler(): void {
    if (this._data.onDecline) {
      this._data.onDecline();
    }
    this.dialogRef.close(false);
  }

  private _createForm(dialogBoxData: MessageDialogBoxDataModel): void {
    this.formGroup = new FormGroup<MessageDialogBoxDataFormGroup>({
      message: new FormControl<string>(dialogBoxData.message!),
    });
  }
}
